<template>
<transition
    name="custom-classes-transition"
    enter-active-class="transition duration-300"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition duration-300"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"

    @after-leave="$emit('update', this.show)"
>
    <div
        class="bg-modal fixed inset-0 w-full h-full z-50 bg-black bg-opacity-50 duration-300 overflow-y-auto"
        v-if="show"
        @click="closeModal"
    >
        <div class="relative mx-2 sm:mx-auto my-12 opacity-100"
            :class="{
                [modalClass] : modalClass
            }"
        >
            <transition
                name="custom-classes-transition"
                enter-active-class="transition transform duration-300"
                enter-from-class="scale-0"
                enter-to-class="scale-100"
                leave-active-class="transition transform duration-300"
                leave-from-class="scale-100"
                leave-to-class="scale-0"
            >
                <div
                    class="relative bg-white shadow-lg rounded-md text-gray-900 z-20"
                    v-if="show"
                >
                <header class="flex flex-col justify-center items-center p-3 text-gray-200 bg-gray-900 rounded-t-md">
                    <h2 class="font-semibold text-xl">{{ title ? title : __('Modal') }}</h2>
                </header>
                <main class="px-3 py-5 text-center overflow-auto">
                    <slot />
                </main>
                </div>
            </transition>
        </div>
    </div>
</transition>
</template>

<script>
export default {
    data() {
        return {
            show: false,
        }
    },
    mounted() {
        this.show = true;
    },
    props: {
        title: String,
        modalClass: {
            type: String,
            default: 'sm:w-3/4 md:w-1/2',
        },
        animateClose: Boolean,
    },
    methods: {
        closeModal(event, close){

            if($(event.target).hasClass('bg-modal') || close){
                this.show = false;
            }
        },
    },
    watch: {
        animateClose(val) {
            if(val) this.show = false;
        }
    }
}
</script>

<style>

</style>
